/* ============================================================
   Clown.art — Sticky ATC bar Custom Element
   Apparaît au scroll après dépassement du bouton ATC original.
   Utilise IntersectionObserver pour détecter la visibilité de
   l'élément cible (data-sticky-atc-anchor).
   ============================================================ */

(function () {
  'use strict';

  class ClownStickyAtc extends HTMLElement {
    constructor() {
      super();
      this._isVisible = false;
      this._scrollPast = false;
      this._anchorInView = true;
      this._scrollThreshold = parseInt(this.getAttribute('data-scroll-threshold'), 10) || 400;
      /* Élément dont le franchissement déclenche la barre. Quand il est
         renseigné, il REMPLACE le seuil en pixels : un seuil fixe ne veut
         rien dire d'un écran à l'autre (400px, c'est encore le hero sur un
         grand moniteur, et c'est déjà passé sur un petit). */
      this._afterSelector = this.getAttribute('data-after-selector') || '';
      this._after = this._afterSelector ? document.querySelector(this._afterSelector) : null;
      this._afterPassed = false;
      this._targetSelector = this.getAttribute('data-target-selector') || '[data-sticky-atc-anchor]';
    }

    connectedCallback() {
      this._target = document.querySelector(this._targetSelector);
      console.debug('[clown-sticky-atc] connected. target=', this._targetSelector, 'found=', !!this._target, 'threshold=', this._scrollThreshold);
      this._initScrollListener();
      this._initIntersectionObserver();
      // Initial state
      this._update();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      if (this._scrollHandler) window.removeEventListener('scroll', this._scrollHandler);
    }

    _initScrollListener() {
      let ticking = false;
      const self = this;
      this._scrollHandler = function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            if (self._after) {
              /* Passé = le bas de l'élément est au-dessus du haut du viewport. */
              const rect = self._after.getBoundingClientRect();
              self._afterPassed = rect.bottom <= 0;
              self._scrollPast = self._afterPassed;
            } else {
              self._scrollPast = window.scrollY > self._scrollThreshold;
            }
            // Also hide near bottom (last 200px)
            const nearBottom = (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200);
            if (nearBottom) {
              self._isAtBottom = true;
            } else {
              self._isAtBottom = false;
            }
            self._update();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', this._scrollHandler, { passive: true });
      /* Évaluation initiale : la page peut être chargée déjà défilée
         (retour arrière, ancre, restauration de position). */
      this._scrollHandler();
    }

    _initIntersectionObserver() {
      if (!this._target || typeof IntersectionObserver === 'undefined') {
        this._anchorInView = false;
        return;
      }
      const self = this;
      this._observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          self._anchorInView = entry.isIntersecting;
          self._update();
        });
      }, { threshold: 0.01 });
      this._observer.observe(this._target);
    }

    _update() {
      // Show when : scrolled past threshold AND target not in view AND not at bottom
      const shouldShow = this._scrollPast && !this._anchorInView && !this._isAtBottom;
      if (shouldShow && !this._isVisible) {
        this._isVisible = true;
        this.removeAttribute('hidden');
        // Force reflow so transition triggers
        // eslint-disable-next-line no-unused-expressions
        this.offsetHeight;
        this.classList.add('is-visible');
      } else if (!shouldShow && this._isVisible) {
        this._isVisible = false;
        this.classList.remove('is-visible');
        // Wait for animation end before hiding (320ms)
        setTimeout(() => {
          if (!this._isVisible) this.setAttribute('hidden', '');
        }, 340);
      }
    }
  }

  if (!customElements.get('clown-sticky-atc')) {
    customElements.define('clown-sticky-atc', ClownStickyAtc);
  }
})();
